class SubCollections extends HTMLElement {
  constructor () {
    super()

    this.setupEventListeners()

    if (this.listEl && this.nextTriggerEl) {
      this.showButtonIfScrollAllowed()
    }

    this.pos = {
      left: 0,
      x: 0,
    }
  }

  setupEventListeners () {
    window.addEventListener('resize', this.showButtonIfScrollAllowed.bind(this))

    this.addEventListener('mousedown', this.mouseDownHandler.bind(this))
  }

  showButtonIfScrollAllowed () {
    const scrollAllowed = this.listEl.parentElement.offsetWidth < this.listEl.scrollWidth
    const scrolledToStart = this.listEl.scrollLeft === 0
    const scrolledToEnd = this.listEl.scrollLeft + this.listEl.offsetWidth === this.listEl.scrollWidth

    this.nextTriggerEl.setAttribute('aria-hidden', !scrollAllowed || scrolledToEnd)
    this.prevTriggerEl.setAttribute('aria-hidden', !scrollAllowed || scrolledToStart)
  }

  mouseDownHandler (e) {
    if (window.innerWidth < 768) return

    this.listEl.style.cursor = 'grabbing'
    this.listEl.style.userSelect = 'none'

    this.pos = {
      left: this.listEl.scrollLeft,
      x: e.clientX,
    }

    const mouseMoveHandler = this.mouseMoveHandler.bind(this)
    const mouseUpHandler = this.mouseUpHandler.bind(this)
    document.addEventListener('mousemove', mouseMoveHandler)
    document.addEventListener('mouseup', mouseUpHandler)

    this.mouseMoveHandlerRef = mouseMoveHandler
    this.mouseUpHandlerRef = mouseUpHandler
  }

  mouseMoveHandler (e) {
    this.listEl.style.pointerEvents = 'none'
    const dx = e.clientX - this.pos.x
    this.listEl.scrollLeft = this.pos.left - dx
  }

  mouseUpHandler () {
    this.listEl.style.cursor = 'grab'
    this.listEl.style.removeProperty('user-select')
    this.listEl.style.removeProperty('pointer-events')

    document.removeEventListener('mousemove', this.mouseMoveHandlerRef)
    document.removeEventListener('mouseup', this.mouseUpHandlerRef)
  }

  set pos (pos) {
    this._pos = pos
  }

  get pos () {
    return this._pos
  }

  get listEl () {
    return this.querySelector('[data-sub_collections-external-el="list"]')
  }

  get nextTriggerEl () {
    return this.querySelector('[data-sub_collections-external-el="nextTrigger"]')
  }

  get prevTriggerEl () {
    return this.querySelector('[data-sub_collections-external-el="prevTrigger"]')
  }
}

customElements.define('sub-collections', SubCollections)
